import type { TrackCompletedAttemptMoneyEvent } from "@circle-react/components/Paywalls/Checkout/hooks/conversionTracking/useTrackConversionEvent";
import { amount } from "@circle-react/helpers/paywalls/currencies";
import type { PaywallCurrencySmallestUnit } from "@circle-react/types/Paywall";
import type { CheckoutAttemptStatus } from "@circle-react/types/PaywallCheckoutAttempt";

import { classifyCompletedMoneyEvent } from "./metaMoneyEventClassification";
import type { MoneyEventClassificationInput } from "./metaMoneyEventClassification";

export interface CompletedAttemptMoneyEventInput {
  attemptId: number;
  attemptStatus: CheckoutAttemptStatus;
  currency: string;
  currencySmallestUnit: PaywallCurrencySmallestUnit;
  hasConfiguredTrial: boolean;
  installmentsCount: number;
  preview?: MoneyEventClassificationInput["preview"];
  priceType: "onetime" | "subscription" | "installments";
  upfrontPaymentAmount: number;
  value: number;
}

export const buildCompletedAttemptMoneyEvent = (
  metadata: CompletedAttemptMoneyEventInput,
): TrackCompletedAttemptMoneyEvent | null => {
  if (metadata.attemptStatus !== "completed") return null;
  const classification = classifyCompletedMoneyEvent(metadata);
  if (!classification) return null;
  const { eventName, value: minorUnits } = classification;
  return {
    attemptId: metadata.attemptId,
    attemptStatus: metadata.attemptStatus,
    currency: metadata.currency,
    eventName,
    value: amount({ smallest_unit: metadata.currencySmallestUnit }, minorUnits),
  };
};
